import { makeApiCall } from '../../_common/api.utils';
import { API_URL } from '../../const';

/** ***************GET PORTFOLIO AT RISK START ************* */
export const PortflioAtRiskDetailsGet = (fetchData: any) => {
	const data = {
		GetPortfolioAtRiskReportToken: fetchData,
	};
	const url = `${API_URL}portfolioProfitRiskReport`;
	return makeApiCall(url, data);
};
/** ***************GET PORTFOLIO AT RISK END ************* */

/** *********************LOAN_INFO_BASEDON_MEMBER START ******** */
export const LoanInfoBasedOnMemberGet = (fetchData: any) => {
	const data = {
		LoanInforBasedOnMemberBothClosedToken: fetchData,
	};
	const url = `${API_URL}getLoanInfoBasedOnMemebers`;
	return makeApiCall(url, data);
};
/** *********************LOAN_INFO_BASEDON_MEMBER END ******** */
